import { render, staticRenderFns } from "./AuthorDetail.vue?vue&type=template&id=5c43be70&"
import script from "./AuthorDetail.vue?vue&type=script&lang=js&"
export * from "./AuthorDetail.vue?vue&type=script&lang=js&"
import style0 from "./AuthorDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports